<p class="mt-4 pb-2 font-bold text-xs">
  {{ 'outlook.summary.note.title' | translate }}
</p>

@if (loading) {
  <maximizer-outlook-skeleton
    containerClasses="h-[120px] w-full rounded-md bg-neutral-25"
  ></maximizer-outlook-skeleton>
} @else if (!configuration.note) {
  <p class="text-body pb-8">
    {{ 'outlook.summary.note.emptyState' | translate }}
  </p>
} @else {
  <div class="mt-2 text-xs space-y-2">
    <div
      class="bg-white w-full rounded border border-neutral-20 flex flex-col p-2 pl-2 mb-2 justify-around relative"
    >
      @if (configuration.note.important) {
        <span
          class="absolute top-3 right-3 fa-icons icon-solid icon-12 icon-exclamation text-error"
          [attr.aria-label]="'outlook.summary.note.important' | translate"
        ></span>
      }

      <div class="flex flex-row">
        <div class="flex-shrink-0">
          <em
            class="mr-1 my-auto fa-icons icon-solid icon-12 icon-note-sticky text-neutral-70"
          ></em>
        </div>
        <div class="flex-1 flex flex-col">
          <span
            class="font-bold my-auto line-clamp-2 mb-2 pr-1 smart-word-break"
            >{{ 'outlook.summary.note.cardTitle' | translate }}

            @let abentryValue = abentry();
            @let leadValue = lead();
            @if (abentryValue) {
              @if (abentryValue.type === 'company') {
                {{ abentryValue.name }}
              } @else {
                {{ abentryValue.firstName }} {{ abentryValue.lastName }}
              }
            } @else if (leadValue) {
              {{ leadValue.name }}
            }
          </span>

          <div
            class="text-neutral-90 mr-1 text-ellipsis overflow-hidden whitespace-nowrap"
          >
            {{ 'outlook.summary.note.createdBy' | translate }}:
          </div>

          <div class="flex items-center gap-2">
            <span class="avatar avatar-xxs bg-inserv-10">{{
              configuration.note.creator | nameInitials
            }}</span>

            <span class="text-neutral-70">{{
              configuration.note.creator
            }}</span>
          </div>

          <p class="text-neutral-70 line-clamp-4 smart-word-break">
            {{ configuration.note.text }}
          </p>
        </div>
      </div>

      <div class="flex">
        <span class="ml-auto caption text-neutral-70 pt-1">{{
          configuration.note.dateTime | date: outlookStore.fullDateTimeFormat()
        }}</span>
      </div>
    </div>
    <span class="text-neutral-70">
      {{ additionalNotes() }}
      {{ 'outlook.summary.note.amount' | translate }}
    </span>
    <a
      id="outlook-note-ui-summaryNote-more"
      class="underline text-link"
      [href]="deepLink()"
      target="_blank"
      rel="noopener"
      >{{ 'outlook.summary.openInMaximizer' | translate }}</a
    >
  </div>
}
